const api_url = "https://clairity-api-k66q7bjmmq-uc.a.run.app/clairity";

export default api_url;